module.exports = __webpack_public_path__ + "img/hero-water-03.0fe7604e.png";